import { Box, IconButton, Stack, Tab, Tabs, Typography, useTheme } from '@mui/material';
import React, { useEffect, useState } from 'react';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import ActivityIndicator from '../../../../components/DataTable/ActivityIndicator';
import NoDataFound from '../../../../components/NoDataFound/NoDataFound';
import { CancelToken } from 'apisauce';
import TabPanel from '../../../../components/TabPanel';
import Details from './Details';
import Reports from './Reports';
import AcceptAndRejectDialog from './AcceptAndRejectDialog';
import appapi from '../../../../api/apiClient';
import moment from 'moment';
import format from '../../../../assets/images/format.svg';
import card from '../../../../assets/images/card.svg';
import { useTranslation } from 'react-i18next';

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

export default function TraderClientDetails({ isDrawerOpen, toggleDrawer, company, init, permission }) {
  const theme = useTheme();
  const text = theme.palette.primary.text;
  const textLight = theme.palette.primary.textLight;

  let source = CancelToken.source();
  let source2 = CancelToken.source();

  
   const {t} = useTranslation()

  const [companyDetails, setCompanyDetails] = useState([]);
 
  const [loading, setLoading] = useState(false);
  const [tabIndexValue, setValue] = React.useState(0);
  const [openAccept, setOpenAccept] = useState(false);
  const [openReject, setOpenReject] = useState(false);

  

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  useEffect(() => {
    if (company && company?.companyId) {
      initApi();
    } else {
    }
    return () => {
      if (source) {
        source.cancel();
      }
    };
  }, [company]);

  const initApi = async () => {
    await getDetails();
  };

  const getDetails = async () => {
    setLoading(true);
    source.cancel();
    source = CancelToken.source();
    const response = await appapi.get(
      `client-management/companyDetails/${company?.companyId}/${company?.traderId}`,
      {},
      {
        cancelToken: source.token,
      },
    );
    if (response.ok) {
      const data = response.data;
      if (data.status === '7400') {
        setCompanyDetails(data?.response);
      }
      setLoading(false);
    } else {
      setLoading(false);
    }
  };

  return (
    <Stack
      flex={1}
      className={!isDrawerOpen ? 'shrinkside flex' : 'expandside flex'}
    >
      <div className="absolute ml-[-16px]">
        <IconButton
          disabled={!Boolean(company)}
          className="!shadow-2xl"
          sx={{ boxShadow: 'rgba(0, 0, 0, 0.5) 1px 5px 10px !important', '&:hover': { width: '40px !important', marginLeft: '-20px' } }}
          style={{
            color: '#00000',
            width: '20px',
            paddingTop: '10px',
            height: '40px',
            zIndex: 999,
            backgroundColor: '#FFFF',
            borderRadius: '10px 0px 0px 10px',
          }}
          onClick={() => {
            toggleDrawer();
          }}
        >
          <ChevronRightIcon />
        </IconButton>
      </div>
      <Stack
        flex={1}
        style={{ background: '#FFFF', border: !isDrawerOpen ? 'none' : '1px solid #14285A1A', width: !isDrawerOpen ? '0px' : '500px', borderRadius: 1 }}
        onClose={() => {
          toggleDrawer();
        }}
      >
        {isDrawerOpen ? (
          <>
            {!companyDetails && !loading && <NoDataFound />}
            {loading && (
              <Stack
                flex={1}
                alignItems={'center'}
                justifyContent={'center'}
              >
                <ActivityIndicator />
              </Stack>
            )}
            {!loading && (
              <>
                <Stack flex={1}>
                  <Box
                    sx={{
                      display: 'flex',
                      borderBottom: 1,
                      border: 'none',
                      color: 'rgba(255, 255, 255, 1)',
                      borderRadius: '5px 5px 0px 0px',
                      justifyContent: 'space-between',
                    }}
                  >
                    <Stack
                      style={{ justifyContent: 'center' }}
                      className="px-[16px]"
                    >
                      <Typography
                        className="fw-medium ff-Roboto fs-16 !capitalize"
                        color={text}
                      >
                        {t('Details')}
                      </Typography>

                      <Stack
                        direction={'row'}
                        alignItems={'center'}
                      >
                        <Typography
                          className="fw-medium ff-Roboto fs-10 !capitalize"
                          color={textLight}
                        >
                          {t('Last modified')}:
                        </Typography>
                        <Typography
                          className="fw-medium ff-Roboto fs-10 !ml-[5px]"
                          color={text}
                        >
                          {moment(companyDetails?.modifiedOn).format('DD-MMM-YYYY')}
                        </Typography>
                        <Typography
                          className="fw-medium ff-Roboto fs-10 !ml-[6px]"
                          color={text}
                        >
                          {/* {moment(shipDetails?.modifiedOn).format('DD-MMM-YYYY')} */}
                        </Typography>
                      </Stack>
                    </Stack>
                    <Tabs
                      sx={{
                        '& .MuiTabs-indicator': {
                          backgroundColor: '#FFCC00 !important',
                        },
                      }}
                      value={tabIndexValue}
                      onChange={handleChange}
                    >
                      <Tab
                       sx={{ minHeight: '56px' }}
                        className="!uppercase !text-#14285A fw-medium ff-Roboto fs-16"
                        label={t('Details')}
                        icon={
                          <img
                            src={card}
                            style={{ width: '16px', height: '12px' }}
                          />
                        }
                        iconPosition="start"
                        {...a11yProps(0)}
                      />
                      {permission.viewAccess && <Tab
                       sx={{ minHeight: '56px' }}
                        className="!uppercase !text-#14285A fw-medium ff-Roboto fs-16"
                        label={t('Reports')}
                        icon={
                          <img
                            src={format}
                            style={{ width: '16px', height: '12px' }}
                          />
                        }
                        iconPosition="start"
                        {...a11yProps(1)}
                      />}
                    </Tabs>
                  </Box>
                  <Stack style={{ backgroundColor: '#8993AC26', width: '100%', height: '1px' }} />
                  {tabIndexValue === 0 && (
                    <TabPanel
                    className="flex flex-col flex-1 min-h-0"
                      value={tabIndexValue}
                      index={0}
                    >
                      <Details
                        setOpenAccept={() => setOpenAccept(true)}
                        setOpenReject={() => setOpenReject(true)}
                        details={companyDetails}
                      />
                    </TabPanel>
                  )}
                  {tabIndexValue === 1 && (
                    <TabPanel
                      className="flex flex-col flex-1 min-h-0"
                      value={tabIndexValue}
                      index={1}
                    >
                      <Reports company={company}/>
                    </TabPanel>
                  )}
                </Stack>
              </>
            )}
          </>
        ) : null}
      </Stack>
      {openAccept && (
        <AcceptAndRejectDialog
          onModelHandleClose={() => setOpenAccept(false)}
          modelOpen={openAccept}
          type={'accept'}
        />
      )}
      {openReject && (
        <AcceptAndRejectDialog
          onModelHandleClose={() => setOpenReject(false)}
          modelOpen={openReject}
          type={'reject'}
        />
      )}
    </Stack>
  );
}
